import React, { useState, useEffect, useContext, Fragment } from "react";
import { NavLink } from "react-router-dom";
import { AppContext } from "../Utils/AppContext";
import { useGetAllCompanies } from "../Utils/Company";
import { getAllFleets } from "../Utils/Fleet";
import { FleetFormCreate } from "../Forms/FleetForm";

import Page from "../Layout/Page";
import FleetTable from "../Tables/FleetTable";

//const [loading, setLoading] = useState(true);

async function loadFleetData(companies) {
  var data = [];
  companies.forEach(async company => {
    await getAllFleets(company.cid).then(fleets => data.push(...fleets));
  });
  return data;
}

const Fleets = () => {
  const context = useContext(AppContext);
  const currentUser = context.state.user;
  const [fleetData, setFleetData] = useState(null);
  const [showFleetForm, setShowFleetForm] = useState(false);

  if (currentUser.role === "super") {
    const { loading: loadingCompanies, companies } = useGetAllCompanies();
    if (companies && !fleetData) {
      loadFleetData(companies).then(data => setFleetData(data));
    }
  }

  return (
    <Page title="Fleets">
      <FleetTable
        companyId={currentUser.role !== "super" && currentUser.company.id}
        uid={currentUser.role === "fleet-manager" && currentUser.uid}
        hideCompany={currentUser.role !== "super"}
        hideDelete={currentUser.role === "fleet-manager"}
      />
      {showFleetForm && (
        <Fragment>
          <br />
          <FleetFormCreate
            companyId={currentUser.role !== "super" && currentUser.company.id}
            formComplete={() => {
              setShowFleetForm(false);
            }}
            hideManagersAndDrivers={currentUser.role === "super"}
          />

          <button
            type="button"
            onClick={() => {
              setShowFleetForm(false);
            }}
          >
            Cancel
          </button>
        </Fragment>
      )}
      {!showFleetForm && currentUser.role !== "fleet-manager" && (
        <Fragment>
          <button
            type="button"
            onClick={() => {
              setShowFleetForm(true);
            }}
          >
            Add Fleet
          </button>
        </Fragment>
      )}
    </Page>
  );
};

export default Fleets;
